<template>
  <div class="bg-page">
    <Form
      ref="dataDetails"
      :model="dataDetails"
      :rules="ruleFrom"
      :label-width="140"
      inline
    >
      <add-double
        :dataDetails="dataDetails"
        :disabledPrice="disabledPrice"
        @addSubmit="addSubmit"
        @changeRadio="changeRadio"
        @delSubmit="delSubmit"
      ></add-double>
      <div class="btn_div">
        <Button
          size="large"
          type="primary"
          :loading="loading"
          @click="createSubmit('dataDetails')"
        >
          {{ $t("order_submit") }}
        </Button>
        <Button
          size="large"
          @click="handleReset('dataDetails')"
          style="margin-left: 8px"
        >
          {{ $t("order_reset") }}
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { doubleCreate } from "@/api/double/list";
import addDouble from "_my/double-add";

export default {
  components: {
    addDouble,
  },
  data() {
    var isInt = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Cannot be empty"));
      }
      this.$nextTick(() => {
        var reg = new RegExp(/^\d+$/);
        if (!reg.test(value)) {
          callback(new Error("Must be a positive integer"));
        } else {
          if (value < 1) {
            callback(new Error("The minimum value is 1"));
          } else {
            callback();
          }
        }
      });
    };
    var minNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Cannot be empty"));
      }
      this.$nextTick(() => {
        if (!this.disabledPrice) {
          var reg = new RegExp(/^\d+(\.\d{0,2})?$/);
          if (!reg.test(value)) {
            callback(new Error("The minimum is a number of 0.01"));
          } else {
            if (value < 0.01) {
              callback(new Error("The minimum is a number of 0.01"));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      });
    };
    return {
      loading: false,
      disabledPrice: true,
      countryList: [],
      cityList: [],
      contList: [],
      // 数据详情
      dataDetails: {
        transportMode: "",
        shipperRef: "",
        remark: "",
        client_id: "",
        cargoInfo: {
          service: "",
          ncndAmt: 0,
          packageType: "XPS",
          battery: "TRUE",
          noofPieces: "",
          weight: "",
          contraband: "",
          cod_amount: 0,
          cod_handlefee: 0,
        },
        invoiceInfo: [
          {
            cargoNumber: "",
            shopName: "",
            caseNumber: 0,
            outNumber: 0,
          },
        ],
        platformInfo: [
          {
            goods_id: "",
            goods_psc: "",
          },
        ],
        consigneeInfo: {
          origin: "",
          country: "",
          company: "",
          contact: "",
          mobile: "",
          tel: "",
          destCode: "",
          address: "",
          address2: "",
          transport: "",
          storeLocation: "",
          claim_volume: "",
        },
      },
      ruleFrom: {
        client_id: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("clientName"),
            trigger: "change",
          },
        ],
        "cargoInfo.service": [
          {
            required: true,
            message: this.$t("select") + this.$t("orderservice"),
            trigger: "change",
          },
        ],
        "cargoInfo.ncndAmt": [
          {
            required: true,
            message: this.$t("select") + this.$t("order_price"),
            trigger: "change",
          },
          { required: true, validator: minNum, trigger: "blur" },
        ],
        "cargoInfo.battery": [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("battery"),
            trigger: "change",
          },
        ],
        "cargoInfo.noofPieces": [
          {
            required: true,
            message: this.$t("select") + this.$t("totalNoofpieces"),
            trigger: "change",
          },
          { required: true, validator: isInt, trigger: "blur" },
        ],
        "cargoInfo.is_solely": [
          {
            required: true,
            message:
              this.$t("select") +
              this.$t("whether") +
              this.$t("separateDeclaration"),
            trigger: "change",
          },
        ],
        "cargoInfo.weight": [
          {
            required: true,
            message: this.$t("enter") + this.$t("wight"),
            trigger: "blur",
          },
        ],
        "consigneeInfo.company": [
          {
            required: true,
            message: this.$t("select") + this.$t("company"),
            trigger: "change",
          },
        ],
        "consigneeInfo.contact": [
          {
            required: true,
            message: this.$t("enter") + this.$t("contact"),
            trigger: "blur",
          },
        ],
        "consigneeInfo.platform": [
          {
            required: true,
            message: this.$tz("请选择,平台"),
            trigger: "blur",
          },
        ],
        "consigneeInfo.mobile": [
          {
            required: true,
            message: this.$t("enter") + this.$t("warehousePhone"),
            trigger: "blur",
          },
          { required: true, validator: isInt, trigger: "blur" },
        ],
        // "consigneeInfo.tel": [
        //   { required: true, validator: isInt, trigger: "blur" }
        // ],
        "consigneeInfo.transport": [
          {
            required: true,
            message: this.$t("enter") + this.$t("method_name"),
            trigger: "change",
          },
        ],
        "consigneeInfo.country": [
          {
            required: true,
            message: this.$t("select") + this.$t("target_country"),
            trigger: "change",
          },
        ],
        "consigneeInfo.company": [
          {
            required: true,
            message: this.$t("select") + this.$t("company"),
            trigger: "change",
          },
        ],

        "consigneeInfo.address": [
          {
            required: true,
            message: this.$t("enter") + this.$t("warehouseAddress1"),
            trigger: "blur",
          },
        ],
      },
      channelList: [],
    };
  },
  methods: {
    delSubmit(index) {
      let arr = this.dataDetails.invoiceInfo;
      this.dataDetails.invoiceInfo = [];
      delete arr[index];
      arr.forEach((item) => {
        this.dataDetails.invoiceInfo.push(item);
      });
    },
    getChannelList(data) {
      getChannel(data)
        .then((res) => {
          let total = res.data.payload.total;
          if (total == 0) {
            this.$Message["error"]({
              background: true,
              content: "No transportation channels",
            });
          } else {
            this.dataDetails.transportMode =
              res.data.payload.rows[0].channel_code;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeRadio(val) {
      if (val != "NCND") {
        this.dataDetails.cargoInfo.ncndAmt = "0";
        this.disabledPrice = true;
      } else {
        this.disabledPrice = false;
      }
    },
    addSubmit() {
      this.dataDetails.invoiceInfo.unshift({
        cargoNumber: "",
        shopName: "",
        caseNumber: 0,
        outNumber: 0,
      });
    },
    createSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true;
          doubleCreate(this.dataDetails)
            .then((res) => {
              this.loading = false;

              if (res.data.status) {
                this.$Message["success"]({
                  background: true,
                  content: "Add Success" + res.data.orderId,
                });
                this.handleReset("dataDetails");
                // this.$router.push({
                //   name: "doubleFeright"
                // });
                // this.$store.dispatch("pageUrl", res.data.orderId);
                // this.$store.dispatch("isDouble", true);
              } else {
                this.$Message["error"]({
                  background: true,
                  content: res.data.message,
                  duration: 5,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      });
    },
    handleReset(name) {
      this.$nextTick(() => {
        this.$refs[name].resetFields();
        let arr = this.dataDetails.invoiceInfo;
        if (arr.length > 1) {
          arr.splice(1, arr.length - 1);
          this.dataDetails.invoiceInfo = arr;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.bg-page {
  overflow: auto;
}
.from-header {
  border: 1px solid#e6e6e6;
  background: #f2f2f2;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: none;
}
.from-header:first-child {
  border-left: 1px solid#e6e6e6;
}
.row-input {
  border: 1px solid#e6e6e6;
  overflow: hidden;
}
.btn_div {
  margin-top: 20px;
  text-align: center;
}
</style>
